import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import {Input, Spin} from 'antd';
import axios from "axios";
import { orders_uri } from "../../utils/url";
import { toast } from "react-toastify";

export default function LeasingModal({data, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
  const [pay, setPay] = useState();

  const Call = () => {
    callback();
  }

  const Submit = async () => {
    setLoad(true);
    try{
        const res = await axios.patch(orders_uri+`/leasing/pay`, {id: data.id, pay: pay, price: data.product.price});
        if(res.status === 200){
            toast.success("Амжилттай");
            onOpenChange(false);
            Call();
        }
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  return (
    <>
      <Button onPress={onOpen}>Дэлгэрэнгүй</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Лизингийн төлбөр төлөх</ModalHeader>
              <ModalBody>
                <div className="font-Roboto">
                    <h1 className="mb-2">{data.phone_or_depo}</h1>
                    <h1 className="font-bold text-sm">Төлсөн төлбөр*</h1>
                    <Input onChange={(e)=> setPay(e.target.value)} className="mt-2" placeholder="Төлбөр оруулах" type="number" value={pay}/>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button color="primary">
                        <Spin/>
                    </Button>
                    :
                    <Button color="primary" onPress={Submit}>
                        Хадгалах
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
